var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_648_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.91602 0.128906C4.7168 0.210938 4.61719 0.28125 4.45898 0.445312C4.18945 0.732422 4.125 0.943359 4.125 1.56445V1.99805L2.36719 2.00391L0.603516 2.01563L0.591797 2.30273L0.585938 2.5957L1.58203 2.60156L2.57812 2.61328L2.5957 8.15625L2.61328 13.6992L2.68359 13.8633C2.88281 14.3613 3.28711 14.7422 3.7793 14.8945C3.96094 14.9531 4.07227 14.9531 7.51172 14.9531C10.9512 14.9531 11.0625 14.9531 11.2441 14.8945C11.7363 14.7422 12.1348 14.3613 12.3398 13.8633L12.4102 13.6992L12.4277 8.15625L12.4453 2.61328L13.4414 2.60156L14.4375 2.5957L14.4258 2.30859L14.4141 2.02148L12.6562 2.00977L10.8984 2.00391L10.8867 1.49414C10.875 1.06055 10.8633 0.960938 10.8105 0.826172C10.6875 0.521484 10.4004 0.240234 10.084 0.123047C9.90234 0.0585937 9.85547 0.0585938 7.49414 0.0585938H5.08594L4.91602 0.128906ZM9.9668 0.691406C10.0898 0.744141 10.2129 0.884766 10.2539 1.02539C10.2715 1.08398 10.2832 1.33008 10.2832 1.57031V2.00391H7.5H4.7168V1.57031C4.7168 1.08984 4.74023 0.960938 4.85742 0.826172C5.00977 0.644531 4.9043 0.65625 7.5 0.650391C9.43945 0.650391 9.89063 0.65625 9.9668 0.691406ZM11.8125 8.12695L11.8008 13.6641L11.7363 13.7988C11.6426 13.998 11.4785 14.1621 11.291 14.2559L11.1211 14.3379H7.5H3.87305L3.70313 14.2559C3.50977 14.1621 3.3457 13.9922 3.25781 13.7988L3.19336 13.6641L3.18164 8.12695L3.17578 2.5957H7.5H11.8184L11.8125 8.12695Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6582 8.53125V12.8789H4.95117H5.24414V8.53125V4.18359H4.95117H4.6582V8.53125Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21875 8.53125V12.8789L7.50586 12.8672L7.79297 12.8555L7.80469 8.51367L7.81055 4.17773H7.51758H7.22461L7.21875 8.53125Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75586 8.53125V12.8789H10.0488H10.3418V8.53125V4.18359H10.0488H9.75586V8.53125Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_648_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.16fc71de6f92b53704689393be55ab34.svg";
export { ForwardRef as ReactComponent };